/**
 * In-memory ring of the last 20 API calls. Stores only method, normalized path
 * (no query string), status, duration and correlation id: never bodies or headers.
 */
import type { ApiCallEntry } from './types';

const CAP = 20;
const MAX_PATH = 200;
const STATE_KEY = Symbol.for('ic.feedback.apiRing');

function ring(): ApiCallEntry[] {
  const g = globalThis as unknown as Record<symbol, ApiCallEntry[] | undefined>;
  g[STATE_KEY] ??= [];
  return g[STATE_KEY];
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function normalizeApiPath(url: string | undefined, baseURL?: string): string {
  let p = url ?? '';
  p = p.replace(/^[a-z][a-z0-9+.-]*:\/\/[^/]+/i, '');
  if (baseURL) {
    const base = baseURL.replace(/^[a-z][a-z0-9+.-]*:\/\/[^/]+/i, '');
    if (base && base !== '/' && p.startsWith(base)) p = p.slice(base.length);
  }
  p = p.split('#')[0]?.split('?')[0] ?? '';
  if (!p.startsWith('/')) p = `/${p}`;
  p = p
    .split('/')
    .map((seg) => (UUID.test(seg) || /^FB-\d+$/i.test(seg) || /^\d+$/.test(seg) ? ':id' : seg))
    .join('/');
  return p.slice(0, MAX_PATH);
}

export function recordApiCall(entry: Omit<ApiCallEntry, 'ts'>): void {
  const r = ring();
  r.push({
    method: entry.method,
    path: entry.path,
    status: entry.status,
    ms: entry.ms,
    correlationId: entry.correlationId,
    ts: Date.now(),
  });
  if (r.length > CAP) r.splice(0, r.length - CAP);
}

export function getApiLog(): ApiCallEntry[] {
  return ring().map((e) => ({ ...e }));
}

export function clearApiLog(): void {
  ring().length = 0;
}
